import { useState, useEffect, Fragment } from 'react'

function FilePreviewItem({ file, onRemove, isLoading, status }) {
    const [thumbnail, setThumbnail] = useState('');
    try {
        
        useEffect(() => {
            if (file && file.type === 'application/pdf') {
                generatePdfThumbnail();
            }
        }, [file]);
        
        const generatePdfThumbnail = async () => {
            try {
                // For now, just show a PDF icon
                // In a real implementation, you could use PDF.js to render the first page
                setThumbnail(null);
            } catch (error) {
                console.error('Error generating PDF thumbnail:', error);
                setThumbnail(null);
            }
        };
        
        // Determine status colors
        let statusColor = 'gray';
        let statusIcon = 'clock';
        
        if (status) {
            if (status.status === 'completed') {
                statusColor = 'green';
                statusIcon = 'check-circle';
            } else if (status.status === 'processing') {
                statusColor = 'blue';
                statusIcon = 'spinner fa-spin';
            } else if (status.status === 'error') {
                statusColor = 'red';
                statusIcon = 'exclamation-circle';
            }
        }
        
        return (
            <div 
                className="flex justify-between items-center p-3 border-b border-gray-200 last:border-b-0 hover:bg-gray-50"
                data-name="file-preview-item"
            >
                <div className="flex items-center space-x-3 flex-1">
                    <div className="w-10 h-10 flex-shrink-0 bg-gray-100 rounded flex items-center justify-center">
                        {thumbnail ? (
                            <img 
                                src={thumbnail} 
                                alt="PDF Preview" 
                                className="w-full h-full object-contain rounded"
                            />
                        ) : (
                            <i className="fas fa-file-pdf text-red-500 text-xl"></i>
                        )}
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="font-medium text-sm truncate" title={file.name}>{file.name}</p>
                        <p className="text-xs text-gray-500">{(file.size / 1024 / 1024).toFixed(2)} MB</p>
                    </div>
                </div>
                
                {status && status.status && (
                    <div className={`mx-4 flex items-center text-${statusColor}-500`}>
                        <i className={`fas fa-${statusIcon} mr-1`}></i>
                        <span className="text-xs">{status.message || ''}</span>
                        
                        {status.status === 'processing' && status.progress > 0 && (
                            <div className="ml-2 w-16 bg-gray-200 rounded-full h-1.5">
                                <div 
                                    className="bg-blue-600 h-1.5 rounded-full" 
                                    style={{ width: `${status.progress}%` }}
                                ></div>
                            </div>
                        )}
                    </div>
                )}
                
                <button
                    type="button"
                    onClick={onRemove}
                    className="text-gray-400 hover:text-gray-600 ml-2"
                    disabled={isLoading}
                    data-name="remove-file-button"
                >
                    <i className="fas fa-times"></i>
                </button>
            </div>
        );
    } catch (error) {
        console.error('FilePreviewItem component error:', error);
        reportError(error);
        return null;
    }
}

export default FilePreviewItem;